export const states = [
    {
        "locationId": 225,
        "countryAbbrev": "CA",
        "stateAbbrev": "AB",
        "stateName": "Alberta",
        "cities": [
            {
                "locationId": 45005,
                "name": "Banff"
            },
            {
                "locationId": 226,
                "name": "Calgary"
            },
            {
                "locationId": 227,
                "name": "Edmonton"
            },
            {
                "locationId": 901,
                "name": "Northern Alberta"
            },
            {
                "locationId": 902,
                "name": "Southern Alberta"
            }
        ]
    },
    {
        "locationId": 228,
        "countryAbbrev": "CA",
        "stateAbbrev": "BC",
        "stateName": "British Columbia",
        "cities": [
            {
                "locationId": 905,
                "name": "Capitol Region & Island"
            },
            {
                "locationId": 39606,
                "name": "Northern British Columbia"
            },
            {
                "locationId": 903,
                "name": "The Interior"
            },
            {
                "locationId": 229,
                "name": "Vancouver/Lower Mainland"
            }
        ]
    },
    {
        "locationId": 230,
        "countryAbbrev": "CA",
        "stateAbbrev": "MB",
        "stateName": "Manitoba",
        "cities": [
            {
                "locationId": 231,
                "name": "Winnipeg"
            }
        ]
    },
    {
        "locationId": 232,
        "countryAbbrev": "CA",
        "stateAbbrev": "NB",
        "stateName": "New Brunswick",
        "cities": [
            {
                "locationId": 45009,
                "name": "Bathurst"
            },
            {
                "locationId": 45007,
                "name": "Campbellton"
            },
            {
                "locationId": 45010,
                "name": "Edmunston"
            },
            {
                "locationId": 906,
                "name": "Fredericton"
            },
            {
                "locationId": 45008,
                "name": "Miramichi"
            },
            {
                "locationId": 907,
                "name": "Moncton"
            },
            {
                "locationId": 908,
                "name": "Saint John"
            }
        ]
    },
    {
        "locationId": 233,
        "countryAbbrev": "CA",
        "stateAbbrev": "NL",
        "stateName": "Newfoundland",
        "cities": [
            {
                "locationId": 909,
                "name": "Newfoundland"
            }
        ]
    },
    {
        "locationId": 235,
        "countryAbbrev": "CA",
        "stateAbbrev": "NT",
        "stateName": "Northwest Territories",
        "cities": [
            {
                "locationId": 910,
                "name": "Northwest Territories"
            }
        ]
    },
    {
        "locationId": 234,
        "countryAbbrev": "CA",
        "stateAbbrev": "NS",
        "stateName": "Nova Scotia",
        "cities": [
            {
                "locationId": 45002,
                "name": "Antigonish and region"
            },
            {
                "locationId": 45001,
                "name": "Cape Breton"
            },
            {
                "locationId": 911,
                "name": "Halifax Regional Area"
            },
            {
                "locationId": 45003,
                "name": "Yarmouth and region"
            }
        ]
    },
    {
        "locationId": 1606,
        "countryAbbrev": "CA",
        "stateAbbrev": "NU",
        "stateName": "Nunavut",
        "cities": [
            {
                "locationId": 1607,
                "name": "All locations"
            }
        ]
    },
    {
        "locationId": 236,
        "countryAbbrev": "CA",
        "stateAbbrev": "ON",
        "stateName": "Ontario",
        "cities": [
            {
                "locationId": 45011,
                "name": "Central Ontario"
            },
            {
                "locationId": 1373,
                "name": "Eastern Ontario"
            },
            {
                "locationId": 237,
                "name": "Hamilton/Burlington"
            },
            {
                "locationId": 45012,
                "name": "Kingston"
            },
            {
                "locationId": 912,
                "name": "Kitchener"
            },
            {
                "locationId": 238,
                "name": "London"
            },
            {
                "locationId": 913,
                "name": "Mississauga"
            },
            {
                "locationId": 915,
                "name": "Northern Ontario"
            },
            {
                "locationId": 45013,
                "name": "Oakville"
            },
            {
                "locationId": 239,
                "name": "Ottawa Region"
            },
            {
                "locationId": 916,
                "name": "South Western Ontario"
            },
            {
                "locationId": 45014,
                "name": "St Catharines / Niagara"
            },
            {
                "locationId": 240,
                "name": "Toronto/GTA"
            },
            {
                "locationId": 45015,
                "name": "Windsor"
            }
        ]
    },
    {
        "locationId": 241,
        "countryAbbrev": "CA",
        "stateAbbrev": "PE",
        "stateName": "Prince Edward Island",
        "cities": [
            {
                "locationId": 917,
                "name": "Prince Edward Island"
            }
        ]
    },
    {
        "locationId": 242,
        "countryAbbrev": "CA",
        "stateAbbrev": "QC",
        "stateName": "Quebec",
        "cities": [
            {
                "locationId": 918,
                "name": "Abitibi/Témiscamingue"
            },
            {
                "locationId": 920,
                "name": "Cantons de l'Est"
            },
            {
                "locationId": 933,
                "name": "Gaspésie/Bas St.Laurent"
            },
            {
                "locationId": 938,
                "name": "Gatineau/Outaouais"
            },
            {
                "locationId": 936,
                "name": "Laurentides"
            },
            {
                "locationId": 45016,
                "name": "Laval"
            },
            {
                "locationId": 921,
                "name": "Maurice-Bois-Francs/Lanaudière"
            },
            {
                "locationId": 922,
                "name": "Montérégie"
            },
            {
                "locationId": 243,
                "name": "Montreal"
            },
            {
                "locationId": 937,
                "name": "Nord du Québec/Manicouagan"
            },
            {
                "locationId": 934,
                "name": "Québec sud ouest"
            },
            {
                "locationId": 919,
                "name": "Région de Quebec"
            },
            {
                "locationId": 935,
                "name": "Saguenay/Lac St.Jean"
            }
        ]
    },
    {
        "locationId": 244,
        "countryAbbrev": "CA",
        "stateAbbrev": "SK",
        "stateName": "Saskatchewan",
        "cities": [
            {
                "locationId": 929,
                "name": "Regina"
            },
            {
                "locationId": 930,
                "name": "Saskatoon"
            },
            {
                "locationId": 39607,
                "name": "Southern Saskatchewan"
            }
        ]
    },
    {
        "locationId": 245,
        "countryAbbrev": "CA",
        "stateAbbrev": "YT",
        "stateName": "Yukon Territory",
        "cities": [
            {
                "locationId": 931,
                "name": "Yukon Territories"
            }
        ]
    },
    {
        "locationId": 248,
        "countryAbbrev": "MX",
        "stateAbbrev": "Ags.",
        "stateName": "Aguascalientes",
        "cities": []
    },
    {
        "locationId": 250,
        "countryAbbrev": "MX",
        "stateAbbrev": "B.C.",
        "stateName": "Baja California",
        "cities": []
    },
    {
        "locationId": 252,
        "countryAbbrev": "MX",
        "stateAbbrev": "B.C.S.",
        "stateName": "Baja California Sur",
        "cities": []
    },
    {
        "locationId": 254,
        "countryAbbrev": "MX",
        "stateAbbrev": "Camp.",
        "stateName": "Campeche",
        "cities": []
    },
    {
        "locationId": 258,
        "countryAbbrev": "MX",
        "stateAbbrev": "Chis.",
        "stateName": "Chiapas",
        "cities": []
    },
    {
        "locationId": 256,
        "countryAbbrev": "MX",
        "stateAbbrev": "Chih.",
        "stateName": "Chihuahua",
        "cities": []
    },
    {
        "locationId": 260,
        "countryAbbrev": "MX",
        "stateAbbrev": "Coah.",
        "stateName": "Coahuila",
        "cities": []
    },
    {
        "locationId": 262,
        "countryAbbrev": "MX",
        "stateAbbrev": "Col.",
        "stateName": "Colima",
        "cities": []
    },
    {
        "locationId": 264,
        "countryAbbrev": "MX",
        "stateAbbrev": "D.F.",
        "stateName": "Distrito Federal",
        "cities": []
    },
    {
        "locationId": 265,
        "countryAbbrev": "MX",
        "stateAbbrev": "Dgo.",
        "stateName": "Durango",
        "cities": []
    },
    {
        "locationId": 279,
        "countryAbbrev": "MX",
        "stateAbbrev": "Méx.",
        "stateName": "Estado de México",
        "cities": []
    },
    {
        "locationId": 270,
        "countryAbbrev": "MX",
        "stateAbbrev": "Gto.",
        "stateName": "Guanajuato",
        "cities": []
    },
    {
        "locationId": 267,
        "countryAbbrev": "MX",
        "stateAbbrev": "Gro.",
        "stateName": "Guerrero",
        "cities": []
    },
    {
        "locationId": 273,
        "countryAbbrev": "MX",
        "stateAbbrev": "Hgo.",
        "stateName": "Hidalgo",
        "cities": []
    },
    {
        "locationId": 275,
        "countryAbbrev": "MX",
        "stateAbbrev": "Jal.",
        "stateName": "Jalisco",
        "cities": []
    },
    {
        "locationId": 277,
        "countryAbbrev": "MX",
        "stateAbbrev": "Mich.",
        "stateName": "Michoacan",
        "cities": []
    },
    {
        "locationId": 282,
        "countryAbbrev": "MX",
        "stateAbbrev": "Mor.",
        "stateName": "Morelos",
        "cities": []
    },
    {
        "locationId": 284,
        "countryAbbrev": "MX",
        "stateAbbrev": "Nay.",
        "stateName": "Nayarit",
        "cities": []
    },
    {
        "locationId": 286,
        "countryAbbrev": "MX",
        "stateAbbrev": "N.L.",
        "stateName": "Nuevo Leon",
        "cities": []
    },
    {
        "locationId": 288,
        "countryAbbrev": "MX",
        "stateAbbrev": "Oax.",
        "stateName": "Oaxaca",
        "cities": []
    },
    {
        "locationId": 290,
        "countryAbbrev": "MX",
        "stateAbbrev": "Pue.",
        "stateName": "Puebla",
        "cities": []
    },
    {
        "locationId": 295,
        "countryAbbrev": "MX",
        "stateAbbrev": "Qro.",
        "stateName": "Queretaro",
        "cities": []
    },
    {
        "locationId": 292,
        "countryAbbrev": "MX",
        "stateAbbrev": "Q.R.",
        "stateName": "Quintana Roo",
        "cities": []
    },
    {
        "locationId": 299,
        "countryAbbrev": "MX",
        "stateAbbrev": "S.L.P.",
        "stateName": "San Luis Potosi",
        "cities": []
    },
    {
        "locationId": 297,
        "countryAbbrev": "MX",
        "stateAbbrev": "Sin.",
        "stateName": "Sinaloa",
        "cities": []
    },
    {
        "locationId": 301,
        "countryAbbrev": "MX",
        "stateAbbrev": "Son.",
        "stateName": "Sonora",
        "cities": []
    },
    {
        "locationId": 303,
        "countryAbbrev": "MX",
        "stateAbbrev": "Tab.",
        "stateName": "Tabasco",
        "cities": []
    },
    {
        "locationId": 305,
        "countryAbbrev": "MX",
        "stateAbbrev": "Tam.",
        "stateName": "Tamaulipas",
        "cities": []
    },
    {
        "locationId": 307,
        "countryAbbrev": "MX",
        "stateAbbrev": "Tlx.",
        "stateName": "Tlaxcala",
        "cities": []
    },
    {
        "locationId": 309,
        "countryAbbrev": "MX",
        "stateAbbrev": "Ver.",
        "stateName": "Veracruz",
        "cities": []
    },
    {
        "locationId": 312,
        "countryAbbrev": "MX",
        "stateAbbrev": "Yuc.",
        "stateName": "Yucatan",
        "cities": []
    },
    {
        "locationId": 47744,
        "countryAbbrev": "MX",
        "stateAbbrev": "Zac.",
        "stateName": "Zacatecas",
        "cities": []
    },
    {
        "locationId": 322,
        "countryAbbrev": "US",
        "stateAbbrev": "AL",
        "stateName": "Alabama",
        "cities": [
            {
                "locationId": 323,
                "name": "Anniston"
            },
            {
                "locationId": 324,
                "name": "Birmingham"
            },
            {
                "locationId": 325,
                "name": "Mobile/Dothan"
            },
            {
                "locationId": 328,
                "name": "Montgomery"
            },
            {
                "locationId": 326,
                "name": "Northern/Huntsville"
            },
            {
                "locationId": 329,
                "name": "Tuscaloosa"
            }
        ]
    },
    {
        "locationId": 317,
        "countryAbbrev": "US",
        "stateAbbrev": "AK",
        "stateName": "Alaska",
        "cities": [
            {
                "locationId": 318,
                "name": "Anchorage"
            },
            {
                "locationId": 319,
                "name": "Fairbanks"
            },
            {
                "locationId": 28889,
                "name": "Far North/Nome"
            },
            {
                "locationId": 320,
                "name": "Juneau"
            },
            {
                "locationId": 28891,
                "name": "Southwest"
            }
        ]
    },
    {
        "locationId": 336,
        "countryAbbrev": "US",
        "stateAbbrev": "AZ",
        "stateName": "Arizona",
        "cities": [
            {
                "locationId": 337,
                "name": "Flagstaff"
            },
            {
                "locationId": 338,
                "name": "Phoenix"
            },
            {
                "locationId": 340,
                "name": "Tucson"
            },
            {
                "locationId": 941,
                "name": "Yuma"
            }
        ]
    },
    {
        "locationId": 330,
        "countryAbbrev": "US",
        "stateAbbrev": "AR",
        "stateName": "Arkansas",
        "cities": [
            {
                "locationId": 333,
                "name": "Eastern"
            },
            {
                "locationId": 334,
                "name": "Little Rock"
            },
            {
                "locationId": 331,
                "name": "Western"
            }
        ]
    },
    {
        "locationId": 32146,
        "countryAbbrev": "US",
        "stateAbbrev": "AA",
        "stateName": "Armed Forces Americas",
        "cities": []
    },
    {
        "locationId": 32145,
        "countryAbbrev": "US",
        "stateAbbrev": "AE",
        "stateName": "Armed Force Europe, the Middle East, and Canada",
        "cities": []
    },
    {
        "locationId": 32147,
        "countryAbbrev": "US",
        "stateAbbrev": "AP",
        "stateName": "Armed Forces Pacific",
        "cities": []
    },
    {
        "locationId": 342,
        "countryAbbrev": "US",
        "stateAbbrev": "CA",
        "stateName": "California",
        "cities": [
            {
                "locationId": 347,
                "name": "Anaheim/Huntington Beach"
            },
            {
                "locationId": 349,
                "name": "Central Coast"
            },
            {
                "locationId": 343,
                "name": "Central Valley"
            },
            {
                "locationId": 344,
                "name": "Chico/Eureka"
            },
            {
                "locationId": 882,
                "name": "Long Beach"
            },
            {
                "locationId": 348,
                "name": "Los Angeles"
            },
            {
                "locationId": 20586,
                "name": "Marin County/North Bay"
            },
            {
                "locationId": 702,
                "name": "Oakland/East Bay"
            },
            {
                "locationId": 350,
                "name": "Orange County"
            },
            {
                "locationId": 20587,
                "name": "Riverside County"
            },
            {
                "locationId": 352,
                "name": "Sacramento"
            },
            {
                "locationId": 351,
                "name": "San Bernardino/Palm Springs"
            },
            {
                "locationId": 354,
                "name": "San Diego"
            },
            {
                "locationId": 355,
                "name": "San Francisco"
            },
            {
                "locationId": 357,
                "name": "Santa Barbara"
            },
            {
                "locationId": 883,
                "name": "Silicon Valley/Peninsula"
            },
            {
                "locationId": 356,
                "name": "Silicon Valley/San Jose"
            },
            {
                "locationId": 698,
                "name": "Ventura County"
            }
        ]
    },
    {
        "locationId": 360,
        "countryAbbrev": "US",
        "stateAbbrev": "CO",
        "stateName": "Colorado",
        "cities": [
            {
                "locationId": 363,
                "name": "Denver"
            },
            {
                "locationId": 361,
                "name": "Boulder/Fort Collins"
            },
            {
                "locationId": 362,
                "name": "Colorado Springs"
            },
            {
                "locationId": 884,
                "name": "Denver South"
            },
            {
                "locationId": 365,
                "name": "Western/Grand Junction"
            }
        ]
    },
    {
        "locationId": 366,
        "countryAbbrev": "US",
        "stateAbbrev": "CT",
        "stateName": "Connecticut",
        "cities": [
            {
                "locationId": 369,
                "name": "Stamford"
            },
            {
                "locationId": 367,
                "name": "Danbury/Bridgeport"
            },
            {
                "locationId": 368,
                "name": "Hartford"
            },
            {
                "locationId": 689,
                "name": "New Haven"
            },
            {
                "locationId": 885,
                "name": "Southeast/New London"
            }
        ]
    },
    {
        "locationId": 372,
        "countryAbbrev": "US",
        "stateAbbrev": "DE",
        "stateName": "Delaware",
        "cities": [
            {
                "locationId": 374,
                "name": "Delaware"
            }
        ]
    },
    {
        "locationId": 696,
        "countryAbbrev": "US",
        "stateAbbrev": "DC",
        "stateName": "District of Columbia",
        "cities": [
            {
                "locationId": 371,
                "name": "Washington/Metro"
            }
        ]
    },
    {
        "locationId": 54897,
        "countryAbbrev": "US",
        "stateAbbrev": "FM",
        "stateName": "Federated States of Micronesia",
        "cities": []
    },
    {
        "locationId": 376,
        "countryAbbrev": "US",
        "stateAbbrev": "FL",
        "stateName": "Florida",
        "cities": [
            {
                "locationId": 377,
                "name": "Daytona Beach"
            },
            {
                "locationId": 378,
                "name": "Ft. Lauderdale"
            },
            {
                "locationId": 379,
                "name": "Ft. Myers/Naples"
            },
            {
                "locationId": 380,
                "name": "Gainesville/Jacksonville/Ocala"
            },
            {
                "locationId": 382,
                "name": "Melbourne"
            },
            {
                "locationId": 383,
                "name": "Miami"
            },
            {
                "locationId": 385,
                "name": "Orlando"
            },
            {
                "locationId": 386,
                "name": "Pensacola/Panama City"
            },
            {
                "locationId": 20585,
                "name": "Sarasota/Bradenton"
            },
            {
                "locationId": 388,
                "name": "St. Petersburg"
            },
            {
                "locationId": 389,
                "name": "Tallahassee"
            },
            {
                "locationId": 390,
                "name": "Tampa"
            },
            {
                "locationId": 391,
                "name": "West Palm Beach"
            }
        ]
    },
    {
        "locationId": 392,
        "countryAbbrev": "US",
        "stateAbbrev": "GA",
        "stateName": "Georgia",
        "cities": [
            {
                "locationId": 950,
                "name": "Atlanta"
            },
            {
                "locationId": 899,
                "name": "Atlanta North"
            },
            {
                "locationId": 886,
                "name": "Atlanta South"
            },
            {
                "locationId": 395,
                "name": "Central/Augusta"
            },
            {
                "locationId": 28888,
                "name": "Northeast"
            },
            {
                "locationId": 398,
                "name": "Savannah"
            },
            {
                "locationId": 942,
                "name": "Southwest"
            }
        ]
    },
    {
        "locationId": 400,
        "countryAbbrev": "US",
        "stateAbbrev": "HI",
        "stateName": "Hawaii",
        "cities": [
            {
                "locationId": 401,
                "name": "Hawaii"
            }
        ]
    },
    {
        "locationId": 411,
        "countryAbbrev": "US",
        "stateAbbrev": "ID",
        "stateName": "Idaho",
        "cities": [
            {
                "locationId": 412,
                "name": "Boise"
            },
            {
                "locationId": 413,
                "name": "Eastern/Twin Falls"
            },
            {
                "locationId": 887,
                "name": "Northern"
            }
        ]
    },
    {
        "locationId": 415,
        "countryAbbrev": "US",
        "stateAbbrev": "IL",
        "stateName": "Illinois",
        "cities": [
            {
                "locationId": 700,
                "name": "Bloomington/Peoria"
            },
            {
                "locationId": 417,
                "name": "Chicago"
            },
            {
                "locationId": 888,
                "name": "Chicago North"
            },
            {
                "locationId": 889,
                "name": "Chicago Northwest"
            },
            {
                "locationId": 890,
                "name": "Chicago South"
            },
            {
                "locationId": 28886,
                "name": "Chicago West"
            },
            {
                "locationId": 422,
                "name": "Quincy"
            },
            {
                "locationId": 423,
                "name": "Rockford"
            },
            {
                "locationId": 419,
                "name": "Southern"
            },
            {
                "locationId": 424,
                "name": "Springfield/Champaign"
            }
        ]
    },
    {
        "locationId": 425,
        "countryAbbrev": "US",
        "stateAbbrev": "IN",
        "stateName": "Indiana",
        "cities": [
            {
                "locationId": 426,
                "name": "Evansville"
            },
            {
                "locationId": 427,
                "name": "Fort Wayne"
            },
            {
                "locationId": 891,
                "name": "Gary/Merrillville"
            },
            {
                "locationId": 428,
                "name": "Indianapolis"
            },
            {
                "locationId": 429,
                "name": "Lafayette"
            },
            {
                "locationId": 430,
                "name": "South Bend"
            },
            {
                "locationId": 431,
                "name": "Terre Haute"
            }
        ]
    },
    {
        "locationId": 403,
        "countryAbbrev": "US",
        "stateAbbrev": "IA",
        "stateName": "Iowa",
        "cities": [
            {
                "locationId": 404,
                "name": "Cedar Rapids"
            },
            {
                "locationId": 406,
                "name": "Central/Des Moines"
            },
            {
                "locationId": 939,
                "name": "Davenport"
            },
            {
                "locationId": 29333,
                "name": "Dubuque"
            },
            {
                "locationId": 408,
                "name": "Western/Sioux City"
            }
        ]
    },
    {
        "locationId": 432,
        "countryAbbrev": "US",
        "stateAbbrev": "KS",
        "stateName": "Kansas",
        "cities": [
            {
                "locationId": 435,
                "name": "Kansas City"
            },
            {
                "locationId": 940,
                "name": "Overland Park"
            },
            {
                "locationId": 434,
                "name": "Topeka/Manhattan"
            },
            {
                "locationId": 437,
                "name": "Wichita Western"
            }
        ]
    },
    {
        "locationId": 438,
        "countryAbbrev": "US",
        "stateAbbrev": "KY",
        "stateName": "Kentucky",
        "cities": [
            {
                "locationId": 439,
                "name": "Bowling Green/Paducah"
            },
            {
                "locationId": 441,
                "name": "Lexington"
            },
            {
                "locationId": 442,
                "name": "Louisville"
            },
            {
                "locationId": 28887,
                "name": "Northern"
            }
        ]
    },
    {
        "locationId": 444,
        "countryAbbrev": "US",
        "stateAbbrev": "LA",
        "stateName": "Louisiana",
        "cities": [
            {
                "locationId": 445,
                "name": "Alexandria"
            },
            {
                "locationId": 446,
                "name": "Baton Rouge"
            },
            {
                "locationId": 447,
                "name": "Lafayette /Lake Charles"
            },
            {
                "locationId": 450,
                "name": "New Orleans"
            },
            {
                "locationId": 449,
                "name": "Northern"
            }
        ]
    },
    {
        "locationId": 461,
        "countryAbbrev": "US",
        "stateAbbrev": "ME",
        "stateName": "Maine",
        "cities": [
            {
                "locationId": 462,
                "name": "Central/Augusta"
            },
            {
                "locationId": 463,
                "name": "Northern/Bangor"
            },
            {
                "locationId": 464,
                "name": "Southern/Portland"
            }
        ]
    },
    {
        "locationId": 456,
        "countryAbbrev": "US",
        "stateAbbrev": "MD",
        "stateName": "Maryland",
        "cities": [
            {
                "locationId": 20583,
                "name": "Anne Arundel County"
            },
            {
                "locationId": 458,
                "name": "Baltimore"
            },
            {
                "locationId": 29334,
                "name": "Columbia"
            },
            {
                "locationId": 20589,
                "name": "Frederick/Hagerstown"
            },
            {
                "locationId": 708,
                "name": "Montgomery County"
            },
            {
                "locationId": 20588,
                "name": "Prince George's County"
            },
            {
                "locationId": 460,
                "name": "Salisbury"
            }
        ]
    },
    {
        "locationId": 452,
        "countryAbbrev": "US",
        "stateAbbrev": "MA",
        "stateName": "Massachusetts",
        "cities": [
            {
                "locationId": 453,
                "name": "Boston"
            },
            {
                "locationId": 893,
                "name": "Boston North"
            },
            {
                "locationId": 892,
                "name": "Boston South"
            },
            {
                "locationId": 20584,
                "name": "Cape Cod/Islands"
            },
            {
                "locationId": 455,
                "name": "Framingham/Worcester"
            },
            {
                "locationId": 454,
                "name": "Western/Springfield"
            }
        ]
    },
    {
        "locationId": 466,
        "countryAbbrev": "US",
        "stateAbbrev": "MI",
        "stateName": "Michigan",
        "cities": [
            {
                "locationId": 468,
                "name": "Ann Arbor"
            },
            {
                "locationId": 470,
                "name": "Detroit"
            },
            {
                "locationId": 707,
                "name": "Flint/Saginaw"
            },
            {
                "locationId": 472,
                "name": "Grand Rapids"
            },
            {
                "locationId": 695,
                "name": "Kalamazoo"
            },
            {
                "locationId": 473,
                "name": "Lansing"
            },
            {
                "locationId": 467,
                "name": "Northern"
            }
        ]
    },
    {
        "locationId": 477,
        "countryAbbrev": "US",
        "stateAbbrev": "MN",
        "stateName": "Minnesota",
        "cities": [
            {
                "locationId": 482,
                "name": "Mankato/Rochester"
            },
            {
                "locationId": 483,
                "name": "Minneapolis"
            },
            {
                "locationId": 480,
                "name": "Northern/Duluth"
            },
            {
                "locationId": 684,
                "name": "St. Paul"
            }
        ]
    },
    {
        "locationId": 498,
        "countryAbbrev": "US",
        "stateAbbrev": "MS",
        "stateName": "Mississippi",
        "cities": [
            {
                "locationId": 502,
                "name": "Central"
            },
            {
                "locationId": 500,
                "name": "Northern"
            },
            {
                "locationId": 499,
                "name": "Southern"
            }
        ]
    },
    {
        "locationId": 486,
        "countryAbbrev": "US",
        "stateAbbrev": "MO",
        "stateName": "Missouri",
        "cities": [
            {
                "locationId": 489,
                "name": "Jefferson City"
            },
            {
                "locationId": 491,
                "name": "Kansas City/Independence"
            },
            {
                "locationId": 492,
                "name": "Northeastern"
            },
            {
                "locationId": 494,
                "name": "Quincy"
            },
            {
                "locationId": 897,
                "name": "Southeastern"
            },
            {
                "locationId": 495,
                "name": "Springfield/Joplin"
            },
            {
                "locationId": 497,
                "name": "St. Louis"
            }
        ]
    },
    {
        "locationId": 504,
        "countryAbbrev": "US",
        "stateAbbrev": "MT",
        "stateName": "Montana",
        "cities": [
            {
                "locationId": 505,
                "name": "Eastern/Billings"
            },
            {
                "locationId": 508,
                "name": "Great Falls"
            },
            {
                "locationId": 699,
                "name": "Helena/Butte"
            },
            {
                "locationId": 510,
                "name": "Western/Missoula"
            }
        ]
    },
    {
        "locationId": 524,
        "countryAbbrev": "US",
        "stateAbbrev": "NE",
        "stateName": "Nebraska",
        "cities": [
            {
                "locationId": 526,
                "name": "Lincoln"
            },
            {
                "locationId": 528,
                "name": "Omaha"
            },
            {
                "locationId": 525,
                "name": "Central/West Nebraska"
            }
        ]
    },
    {
        "locationId": 539,
        "countryAbbrev": "US",
        "stateAbbrev": "NV",
        "stateName": "Nevada",
        "cities": [
            {
                "locationId": 541,
                "name": "Las Vegas"
            },
            {
                "locationId": 542,
                "name": "Reno"
            }
        ]
    },
    {
        "locationId": 683,
        "countryAbbrev": "US",
        "stateAbbrev": "NH",
        "stateName": "New Hampshire",
        "cities": [
            {
                "locationId": 705,
                "name": "Northern"
            },
            {
                "locationId": 530,
                "name": "Southern"
            }
        ]
    },
    {
        "locationId": 682,
        "countryAbbrev": "US",
        "stateAbbrev": "NJ",
        "stateName": "New Jersey",
        "cities": [
            {
                "locationId": 532,
                "name": "Central"
            },
            {
                "locationId": 534,
                "name": "Northern"
            },
            {
                "locationId": 533,
                "name": "Southern"
            }
        ]
    },
    {
        "locationId": 536,
        "countryAbbrev": "US",
        "stateAbbrev": "NM",
        "stateName": "New Mexico",
        "cities": [
            {
                "locationId": 537,
                "name": "Albuquerque"
            },
            {
                "locationId": 685,
                "name": "Santa Fe"
            }
        ]
    },
    {
        "locationId": 543,
        "countryAbbrev": "US",
        "stateAbbrev": "NY",
        "stateName": "New York",
        "cities": [
            {
                "locationId": 544,
                "name": "Albany/Poughkeepsie"
            },
            {
                "locationId": 545,
                "name": "Binghamton/Elmira"
            },
            {
                "locationId": 546,
                "name": "Buffalo"
            },
            {
                "locationId": 549,
                "name": "Long Island"
            },
            {
                "locationId": 550,
                "name": "New York City"
            },
            {
                "locationId": 547,
                "name": "Northern"
            },
            {
                "locationId": 552,
                "name": "Rochester"
            },
            {
                "locationId": 553,
                "name": "Syracuse"
            },
            {
                "locationId": 554,
                "name": "Utica"
            },
            {
                "locationId": 556,
                "name": "Westchester"
            }
        ]
    },
    {
        "locationId": 511,
        "countryAbbrev": "US",
        "stateAbbrev": "NC",
        "stateName": "North Carolina",
        "cities": [
            {
                "locationId": 512,
                "name": "Charlotte"
            },
            {
                "locationId": 515,
                "name": "Eastern/Greenville"
            },
            {
                "locationId": 514,
                "name": "Greensboro"
            },
            {
                "locationId": 516,
                "name": "Raleigh/Durham-RTP"
            },
            {
                "locationId": 517,
                "name": "Western/Asheville"
            },
            {
                "locationId": 513,
                "name": "Wilmington/Fayetteville"
            },
            {
                "locationId": 519,
                "name": "Winston Salem"
            }
        ]
    },
    {
        "locationId": 520,
        "countryAbbrev": "US",
        "stateAbbrev": "ND",
        "stateName": "North Dakota",
        "cities": [
            {
                "locationId": 521,
                "name": "Central"
            },
            {
                "locationId": 522,
                "name": "Eastern"
            },
            {
                "locationId": 523,
                "name": "Western"
            }
        ]
    },
    {
        "locationId": 54898,
        "countryAbbrev": "US",
        "stateAbbrev": "MP",
        "stateName": "Northern Mariana Islands",
        "cities": []
    },
    {
        "locationId": 557,
        "countryAbbrev": "US",
        "stateAbbrev": "OH",
        "stateName": "Ohio",
        "cities": [
            {
                "locationId": 558,
                "name": "Akron"
            },
            {
                "locationId": 559,
                "name": "Cincinnati"
            },
            {
                "locationId": 560,
                "name": "Cleveland"
            },
            {
                "locationId": 561,
                "name": "Columbus/Zanesville"
            },
            {
                "locationId": 562,
                "name": "Dayton"
            },
            {
                "locationId": 28890,
                "name": "Middletown"
            },
            {
                "locationId": 563,
                "name": "Northwest"
            },
            {
                "locationId": 29331,
                "name": "Toledo"
            },
            {
                "locationId": 566,
                "name": "Youngstown"
            }
        ]
    },
    {
        "locationId": 568,
        "countryAbbrev": "US",
        "stateAbbrev": "OK",
        "stateName": "Oklahoma",
        "cities": [
            {
                "locationId": 569,
                "name": "Central-Oklahoma City"
            },
            {
                "locationId": 571,
                "name": "Eastern/Tulsa"
            }
        ]
    },
    {
        "locationId": 573,
        "countryAbbrev": "US",
        "stateAbbrev": "OR",
        "stateName": "Oregon",
        "cities": [
            {
                "locationId": 574,
                "name": "Central"
            },
            {
                "locationId": 578,
                "name": "Portland"
            },
            {
                "locationId": 579,
                "name": "Salem"
            },
            {
                "locationId": 576,
                "name": "Southern"
            }
        ]
    },
    {
        "locationId": 580,
        "countryAbbrev": "US",
        "stateAbbrev": "PA",
        "stateName": "Pennsylvania",
        "cities": [
            {
                "locationId": 581,
                "name": "Allentown"
            },
            {
                "locationId": 582,
                "name": "Erie"
            },
            {
                "locationId": 583,
                "name": "Harrisburg"
            },
            {
                "locationId": 584,
                "name": "Johnstown"
            },
            {
                "locationId": 585,
                "name": "Philadelphia"
            },
            {
                "locationId": 586,
                "name": "Pittsburgh"
            },
            {
                "locationId": 29332,
                "name": "Reading"
            },
            {
                "locationId": 704,
                "name": "State College"
            },
            {
                "locationId": 588,
                "name": "Wilkes Barre"
            },
            {
                "locationId": 703,
                "name": "York/Lancaster"
            }
        ]
    },
    {
        "locationId": 315,
        "countryAbbrev": "US",
        "stateAbbrev": "PR",
        "stateName": "Puerto Rico",
        "cities": [
            {
                "locationId": 1384,
                "name": "San Juan"
            }
        ]
    },
    {
        "locationId": 590,
        "countryAbbrev": "US",
        "stateAbbrev": "RI",
        "stateName": "Rhode Island",
        "cities": [
            {
                "locationId": 591,
                "name": "Providence"
            }
        ]
    },
    {
        "locationId": 592,
        "countryAbbrev": "US",
        "stateAbbrev": "SC",
        "stateName": "South Carolina",
        "cities": [
            {
                "locationId": 594,
                "name": "Columbia"
            },
            {
                "locationId": 595,
                "name": "Florence/Myrtle Beach"
            },
            {
                "locationId": 596,
                "name": "Greenville/Spartanburg"
            },
            {
                "locationId": 593,
                "name": "South/Charleston"
            }
        ]
    },
    {
        "locationId": 597,
        "countryAbbrev": "US",
        "stateAbbrev": "SD",
        "stateName": "South Dakota",
        "cities": [
            {
                "locationId": 598,
                "name": "East/Sioux Falls"
            },
            {
                "locationId": 600,
                "name": "West/Rapid City"
            }
        ]
    },
    {
        "locationId": 602,
        "countryAbbrev": "US",
        "stateAbbrev": "TN",
        "stateName": "Tennessee",
        "cities": [
            {
                "locationId": 603,
                "name": "Chattanooga"
            },
            {
                "locationId": 604,
                "name": "Jackson"
            },
            {
                "locationId": 605,
                "name": "Knoxville"
            },
            {
                "locationId": 606,
                "name": "Memphis"
            },
            {
                "locationId": 607,
                "name": "Nashville"
            }
        ]
    },
    {
        "locationId": 609,
        "countryAbbrev": "US",
        "stateAbbrev": "TX",
        "stateName": "Texas",
        "cities": [
            {
                "locationId": 610,
                "name": "Abilene/Odessa"
            },
            {
                "locationId": 611,
                "name": "Amarillo/Lubbock"
            },
            {
                "locationId": 612,
                "name": "Austin"
            },
            {
                "locationId": 615,
                "name": "Dallas"
            },
            {
                "locationId": 613,
                "name": "East/Tyler/Beaumont"
            },
            {
                "locationId": 616,
                "name": "El Paso"
            },
            {
                "locationId": 686,
                "name": "Fort Worth"
            },
            {
                "locationId": 619,
                "name": "Houston"
            },
            {
                "locationId": 624,
                "name": "San Antonio"
            },
            {
                "locationId": 618,
                "name": "South/Corpus Christi"
            },
            {
                "locationId": 627,
                "name": "Waco"
            },
            {
                "locationId": 628,
                "name": "Wichita Falls"
            }
        ]
    },
    {
        "locationId": 629,
        "countryAbbrev": "US",
        "stateAbbrev": "UT",
        "stateName": "Utah",
        "cities": [
            {
                "locationId": 692,
                "name": "Provo"
            },
            {
                "locationId": 630,
                "name": "Salt Lake City"
            },
            {
                "locationId": 29335,
                "name": "St. George"
            }
        ]
    },
    {
        "locationId": 642,
        "countryAbbrev": "US",
        "stateAbbrev": "VT",
        "stateName": "Vermont",
        "cities": [
            {
                "locationId": 529,
                "name": "Northern"
            },
            {
                "locationId": 706,
                "name": "Southern"
            }
        ]
    },
    {
        "locationId": 641,
        "countryAbbrev": "US",
        "stateAbbrev": "VI",
        "stateName": "Virgin Islands",
        "cities": [
            {
                "locationId": 1383,
                "name": "St. Croix"
            },
            {
                "locationId": 1381,
                "name": "St. John"
            },
            {
                "locationId": 1382,
                "name": "St. Thomas"
            }
        ]
    },
    {
        "locationId": 631,
        "countryAbbrev": "US",
        "stateAbbrev": "VA",
        "stateName": "Virginia",
        "cities": [
            {
                "locationId": 894,
                "name": "Alexandria"
            },
            {
                "locationId": 634,
                "name": "Charlottesville/Harrisonburg"
            },
            {
                "locationId": 693,
                "name": "Fairfax/Manassas/Reston"
            },
            {
                "locationId": 895,
                "name": "McLean/Arlington"
            },
            {
                "locationId": 635,
                "name": "Norfolk/Hampton Roads"
            },
            {
                "locationId": 701,
                "name": "Northern"
            },
            {
                "locationId": 637,
                "name": "Richmond"
            },
            {
                "locationId": 638,
                "name": "Roanoke"
            },
            {
                "locationId": 20590,
                "name": "Southwest"
            },
            {
                "locationId": 694,
                "name": "Vienna"
            }
        ]
    },
    {
        "locationId": 645,
        "countryAbbrev": "US",
        "stateAbbrev": "WA",
        "stateName": "Washington",
        "cities": [
            {
                "locationId": 896,
                "name": "Bellevue/Redmond"
            },
            {
                "locationId": 649,
                "name": "Central/Yakima"
            },
            {
                "locationId": 648,
                "name": "Eastern/Spokane"
            },
            {
                "locationId": 647,
                "name": "Seattle"
            },
            {
                "locationId": 697,
                "name": "Tacoma/Olympia"
            }
        ]
    },
    {
        "locationId": 660,
        "countryAbbrev": "US",
        "stateAbbrev": "WV",
        "stateName": "West Virginia",
        "cities": [
            {
                "locationId": 663,
                "name": "Northern"
            },
            {
                "locationId": 661,
                "name": "Southern"
            }
        ]
    },
    {
        "locationId": 650,
        "countryAbbrev": "US",
        "stateAbbrev": "WI",
        "stateName": "Wisconsin",
        "cities": [
            {
                "locationId": 654,
                "name": "Eau Claire/LaCrosse"
            },
            {
                "locationId": 653,
                "name": "Green Bay/Appleton"
            },
            {
                "locationId": 655,
                "name": "Madison"
            },
            {
                "locationId": 656,
                "name": "Milwaukee"
            },
            {
                "locationId": 659,
                "name": "Northern"
            }
        ]
    },
    {
        "locationId": 666,
        "countryAbbrev": "US",
        "stateAbbrev": "WY",
        "stateName": "Wyoming",
        "cities": [
            {
                "locationId": 667,
                "name": "Casper"
            },
            {
                "locationId": 668,
                "name": "Cheyenne"
            }
        ]
    }
];
export const countries = [
    {
        "code": "CA",
        "name": "Canada"
    },
    {
        "code": "MX",
        "name": "Mexico"
    },
    {
        "code": "US",
        "name": "United States"
    }
];